/**
 * `/foodcost` — Controllo di gestione ristorazione (Studio Ferrari).
 *
 * Modulo **su misura di un cliente**, non di piattaforma: sta dietro il feature flag
 * `foodcost.enabled` e i suoi dati non toccano il modello del backend. Vedi `store.ts`.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PeriodsPage } from '@/features/foodcost/PeriodsPage';

export const Route = createFileRoute('/_app/foodcost/')({ component: PeriodsPage });
